import { gql, useMutation } from '@apollo/client'
import { UpdatePlaylistInput } from '@frontend-mono/shared/data-access-graphql'

const UPDATE_PLAYLIST = gql`
  mutation UpdatePlaylist($input: UpdatePlaylistInput!) {
    updatePlaylist(input: $input) {
      playlist {
        id
        title
        pinned
        topics {
          id
        }
      }
    }
  }
`

type Response = {
  updatePlaylist: {
    playlist: {
      __typename: string
      id: string
      title?: string | null,
      pinned?: boolean | null,
      topics?: {
        id: string
      }[] | null
    }
  }
}

export const useUpdatePlaylist = () => {
  const [updatePlaylistRequest, { loading }] = useMutation<
    Response,
    { input: UpdatePlaylistInput }
  >(UPDATE_PLAYLIST)

  const updatePlaylist = async ({
    playlist,
    onSuccess,
  }: {
    playlist: UpdatePlaylistInput
    onSuccess?: () => void
  }) => {
    await updatePlaylistRequest({
      variables: {
        input: playlist,
      },
      refetchQueries: [
        'GetPlaylist',
      ],
      onCompleted: onSuccess,
      optimisticResponse: {
        updatePlaylist: {
          playlist: {
            __typename: 'Playlist',
            id: playlist.id,
            pinned: playlist.pinned,
            title: playlist.title,
            topics: playlist.topicIds ?? [],
          },
        },
      },
    })
  }

  return {
    loading,
    updatePlaylist,
  }
}
